import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { AppActions } from '@/app/app.keys';
import store from '@/store';
import i18n from '@/i18n';

// meta authGuard implies that authenticated is due for this page
// see https://router.vuejs.org/guide/advanced/meta.html#route-meta-fields .
// the login page, for instance, does not require authentication
export function authGuard(to, from, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('tol-token');
    const redirect = to.path !== '/' || to.path !== '/login' ? to.path : '';
    store.dispatch(AppActions.SetRedirect, redirect);
    if ((token === 'null' || token === undefined) && to.path != '/') {
      store.dispatch(TolErrorsActions.SetError, { message: i18n.t('login.errors.loginFirst') });
      store.dispatch(TolErrorsActions.SetKeepOnce);
      next({ path: `/login` });
    } else if (!token || (token === 'null' && to.path === '/')) {
      next({ path: `/login` });
    } else {
      store.dispatch(AppActions.RetrieveSession);
      next();
    }
  } else {
    next();
  }
}
